import React from 'react';
import {hasValue} from '@packages/utilities/string-utils';
import {iconName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';

const createOption = (option: any, index: any) => {
  const value = option?.v;
  const text = option?.t;
  return (
    <option key={index} value={hasValue(value) ? value : ''}>
      {hasValue(text) ? text : ''}
    </option>
  );
};

const FormSelect = Atom.createRender(
  ({attributes, classes, generateAttributes, data}) => {
    const selectClasses = classes.push('w-select');
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const options = (data?.form?.opts ?? []).map(createOption);

    return (
      <select {...generateAttributes(attributes, selectClasses)}>
        {options}
      </select>
    );
  }
);

const config = Atom.create({
  displayName: 'Select Field',
  constraints: {
    ancestors: [
      {
        is: 'FormForm',
        rule: 'ExactlyOne',
      },
    ],
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Select')),
  },
  showEmpty: false,
  render: FormSelect,
  dataType: createIntegratedRootAliasInstance(
    qualify(Plugins.name('Form'), typeName('FormSelect'))
  ),
});

export default config;
